import { useMemo } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../consts";
import { t } from "../../../services";
import { useSelectedFilterOptionsState } from "../hooks/useSelectedFilterOptionsState";

import Modal from "../../Modal/Modal";
import WrapperContainer from "../../Containers/WrapperContainer";
import SmallButton from "../../Buttons/SmallButton";
import FlexContainers from "../../Containers/FlexContainers";

import { Description, FilterModalContainer } from "../styled";
import FilterOptionsTable from "./FilterOptionsTable";

export const FilterModal = ({
  active,
  setActive,
  options,
  selectedOptions,
  onSubmit,
  title,
  description,
  searchPlaceholder,
  columnName,
  CellComponent,
  Component,
  selectedOptionsState
}) => {
  const {
    selectedOptionsState: _selectedOptionsState,
    onOptionSelected,
    onSelectAll
  } = useSelectedFilterOptionsState(selectedOptions, options, active);

  const hasCustomComponent = useMemo(() => {
    return !!Component && !!selectedOptionsState;
  }, [Component, selectedOptionsState]);

  const handleSubmit = () => {
    onSubmit(hasCustomComponent ? selectedOptionsState : _selectedOptionsState);
    setActive(false);
  };

  return (
    <Modal
      active={active}
      setActive={setActive}
      title={title}
      closable={false}
      Container={FilterModalContainer}
      modalFooter={
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} width={"100%"}>
          <SmallButton secondary onClick={() => setActive(false)}>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>

          <SmallButton onClick={handleSubmit}>{t(strCode.DONE_BTN)}</SmallButton>
        </WrapperContainer>
      }>
      <Description>{description}</Description>

      {Component ? (
        Component
      ) : (
        <FilterOptionsTable
          onOptionsSelected={onOptionSelected}
          onSelectAll={onSelectAll}
          options={options}
          selectedOptions={_selectedOptionsState}
          searchPlaceholder={searchPlaceholder}
          columnName={columnName}
          CellComponent={CellComponent}
        />
      )}
    </Modal>
  );
};

FilterModal.propTypes = {
  active: PropTypes.bool,
  setActive: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  searchPlaceholder: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  CellComponent: PropTypes.object,
  Component: PropTypes.node,
  selectedOptionsState: PropTypes.array
};
